import { useNavigator } from '@repo/toolkit/use-navigator'
import { BusTwoIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createCoachCompany } from '../../../api/ols/coach-companies/create-coach-companies'
import UserNavBar from '../../../components/elements/nav-bar'
import CoachCompanyForm from '../../../components/pages/ols/coach-companies/coach-company-form'
import { Paths } from '../../../lib/constants/path'
import useAuth from '../../../lib/hooks/use-auth'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

const CoachCompaniesCreatePage = () => {
  const { navigate, back } = useNavigator()
  const { user } = useAuth()

  const { mutateAsync } = useMutation({
    mutationFn: createCoachCompany,
    onError: showAxiosError,
    onSuccess: (data) => {
      navigate(
        Paths.OL_PERSONAL_SPACE_COACH_COMPANIES_UPDATE_PAGE.replace(':id', data.id.toString())
      )
      toast.success('Coach company created successfully')
    }
  })

  const olId = user?.ol?.id

  if (!olId) return null

  return (
    <div>
      <UserNavBar title={'Add coach company'} icon={BusTwoIcon} />
      <div className={'h-4'} />
      <CoachCompanyForm
        country={user?.ol?.country ?? 'FR'}
        buttonsConfig={twoButtonsConfig({
          onCancel: () => back(Paths.OL_PERSONAL_SPACE_COACH_COMPANIES_LIST_PAGE),
          onConfirm: async (values) => await mutateAsync({ ...values, olId }),
          isEnglish: true
        })}
      />
    </div>
  )
}

export default CoachCompaniesCreatePage
